import { render } from "./EditClientModal.vue?vue&type=template&id=40c3e871"
import script from "./EditClientModal.vue?vue&type=script&lang=js"
export * from "./EditClientModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__